import React from 'react';
import { withLayout } from '../../templates/layout';

const Screen = React.lazy(() => {
  return import(/* webpackChunkName: "claim-view-screen" */ './components');
});

export default withLayout({
  component: Screen,
});
